import { objectOf } from "@altostra/type-validations";
import { string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesResult = objectOf({
  audience: objectOf({
    id: string,
    name: string,
    data_type: string,
    status: nullOrUndefined,
  }),
});
